import endpoints from '@app/src/api/endpoints'
import { Option } from '@app/src/components/Form/Select'
import Select from '@app/src/components/Form/Select/ControlledSelect'
import { Operators } from '@app/src/pages/ResourceCollection/Filters/useFilters'
import { SortOrder } from '@app/src/types/filter'
import { Request } from '@app/src/types/resourceExplorer'
import { insertIf } from '@app/src/utils/helpersTs'
import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

interface SelectTemplateScrapingProps {
  name: string
}

const SelectTemplateForScraping: React.FC<SelectTemplateScrapingProps> = ({ name }) => {
  const { worldfavorStandardTemplatesThatCanBeScreened } = useFlags()
  const { control } = useFormContext()
  const { formatMessage } = useIntl()

  const canScreenAllStandardTemplates =
    worldfavorStandardTemplatesThatCanBeScreened.length === 1 &&
    worldfavorStandardTemplatesThatCanBeScreened[0].toLowerCase() === 'all'
  return (
    <Select<{ title: string; id: number }, Request>
      name={name}
      fieldLabel={formatMessage({ id: 'form.createRequest.selectTemplateLabel' })}
      control={control}
      required
      enableAutoSelect
      multiple
      forceFetch
      navigation={{
        url: endpoints.worldfavorTemplates,
        type: 'post',
        postObject: {
          include: [],
          filter: [
            ...insertIf(!canScreenAllStandardTemplates, {
              name: 'title',
              filters: [
                {
                  value: worldfavorStandardTemplatesThatCanBeScreened,
                  operator: Operators.In,
                },
              ],
            }),
          ],
          sort: { target: 'title', order: SortOrder.ASCENDING },
        },
      }}
      findSelectedValue={(value, option): boolean => value?.id === option?.value?.id}
      objectToOption={({ title, id }: Request): Option<{ title: string; id: number }> => ({
        label: title,
        value: { title, id },
      })}
    />
  )
}

export default SelectTemplateForScraping
